import { Seo, breadcrumbJsonLd, SERVICE_JSONLD } from "@/lib/Seo";
import { PageHeader } from "@/components/PageHeader";
import { Applications } from "@/sections/Applications";
import { Reveal } from "@/components/Reveal";
import { SEO_SECTIONS } from "@/data/content";
import { Link } from "react-router-dom";
import { btnPrimary } from "@/lib/ui";
import { ArrowRight } from "lucide-react";

const BREADCRUMB = [
  { name: "Home", path: "/" },
  { name: "Toepassingen", path: "/toepassingen" },
];

export default function ApplicationsPage() {
  return (
    <>
      <Seo
        title="Toepassingen thermische camera's in de recyclingsector"
        description="Thermische branddetectie voor afvalbunkers, papieropslag, kunststofrecycling, metaalrecycling, batterijopslag, transportbanden en buitenopslag. Bekijk alle toepassingen."
        jsonLd={[breadcrumbJsonLd(BREADCRUMB), SERVICE_JSONLD]}
      />
      <PageHeader
        overline="Toepassingen"
        title="Thermische bewaking voor iedere risicozone"
        intro="Iedere recyclingstroom kent eigen risico's. Wij ontwerpen de detectieoplossing rond de gebieden waar warmteontwikkeling het grootste gevaar vormt."
        breadcrumb={BREADCRUMB}
      />
      <Applications />
      <section className="py-24" data-testid="seo-sections">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 md:grid-cols-2 lg:px-10 xl:grid-cols-3">
          {SEO_SECTIONS.map((section, i) => (
            <Reveal key={section.id} delay={(i % 3) * 0.08} className="h-full">
              <article id={section.id} className="h-full rounded-2xl border border-white/10 bg-[#10232F]/40 p-7">
                <h2 className="font-heading text-base font-bold text-[#F5F7F9] md:text-lg">{section.title}</h2>
                <p className="mt-3 text-sm leading-relaxed text-[#CBD3D9]/85">{section.text}</p>
                <Link to="/offerte" className="mt-4 inline-flex items-center gap-2 font-heading text-xs font-semibold uppercase tracking-[0.15em] text-[#62C3F0] transition-colors hover:text-[#F5F7F9]">
                  Vraag een offerte aan <ArrowRight size={13} />
                </Link>
              </article>
            </Reveal>
          ))}
        </div>
        <div className="mx-auto mt-16 max-w-7xl px-4 sm:px-6 lg:px-10">
          <Link to="/offerte" className={btnPrimary} data-testid="applications-page-cta">
            Bespreek uw terrein met een specialist <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </>
  );
}
